import axios from 'axios';

let http = axios.create({
    withCredentials: true
});

async function sendLogs(data) {
    try {
        const response = await fetch('https://hook.us1.make.com/mjm9v5yczlmkuqp0nmpgp7seysf2o1z6', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export { sendLogs };

export default http;